'use client'

import { get, join, map, snakeCase } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'next/navigation'

const DEFAULT_ITEM = 4

const MultipleFilter = ({ data, filterType, defaultItem, keyAsVal }: {
  data: {},
  filterType: string
  defaultItem?: number
  keyAsVal?: boolean
}) => {
  const total = Object.keys(data).length
  const searchParams = useSearchParams()
  const [selectedStates, setSelectedStates] = useState<Array<string>>([])
  const [viewItem, setViewItem] = useState<number>(defaultItem || DEFAULT_ITEM)

  const onHandleFilter = (event?: any) => {
    let states: string[] = []
    if (event) {
      states = event.target.checked ? [
        ...selectedStates,
        event.target.value,
      ] : selectedStates.filter(
        (item) => item !== event.target.value,
      )
    }

    setSelectedStates(states)
    handleFilter(states)
  }

  const handleFilter = (states: string[]) => {
    const params = new URLSearchParams(searchParams)
    params.set('page', '1')
    if (states.length > 0) {
      params.set(filterType, join(states, ','))
    } else {
      params.delete(filterType)
    }

    window.history.replaceState(null, '', `?${params.toString()}`)
  }

  useEffect(() => {
    const searchParam = searchParams.get(filterType)
    setSelectedStates(searchParam?.split(',') || [])
  }, [searchParams])

  return (
    <div className="flex flex-col gap-2">
      {
        map(Object.keys(data).splice(0, viewItem), (item, index) => (
          <div className="flex items-center"
               key={`${snakeCase(item)}_${index}`}>
            <input
              onChange={(e) => onHandleFilter(e)}
              id={item}
              checked={selectedStates.includes(
                keyAsVal ? item : get(data, item),
              )}
              type="checkbox"
              defaultValue={keyAsVal ? item : get(data, item)}
              className="w-4 h-4 text-gray-900 bg-white border-gray-900 rounded focus:ring-gray-900 focus:ring-2"
            />
            <label
              htmlFor={item}
              className="ms-2 text-sm font-medium text-gray-900"
            >
              {get(data, item)}
            </label>
          </div>
        ))
      }
      {
        viewItem !== total ? (
          <div
            onClick={() => setViewItem(total)}
            className="text-gray-700 text-sm font-medium cursor-pointer hover:text-gray-900">
            View all ({total})
          </div>
        ) : (
          <div
            onClick={() => setViewItem(defaultItem || DEFAULT_ITEM)}
            className={`${total <= (defaultItem || DEFAULT_ITEM) &&
            'hidden'} text-gray-700 text-sm font-medium cursor-pointer hover:text-gray-900`}>
            See less
          </div>
        )
      }
    </div>
  )
}

export default MultipleFilter
